import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "d-none",
    };

    this.handleVerify = this.handleVerify.bind(this);
  }

  handleVerify(e) {
    e.preventDefault();
    let OTP = this.props.OTP;
    if (OTP === "") {
      this.setState({
        display: "d-block",
      });
      setTimeout(() => {
        this.setState({
          display: "d-none",
        });
      }, 2000);
    } else {
      this.props.submitCode(OTP);
     
    }
  }

  render() {
    if (this.props.currentStep !== 2) {
      return null;
    }
    return (
      <React.Fragment>
        <div
          className="col-lg-12 col-md-12 col-sm-12 form-group"
          data-for="name"
        >
          <input
            type="text"
            name="OTP"
            placeholder="Enter OTP"
            data-form-field="OTP"
            className="form-control"
            value={this.props.OTP}
            onChange={this.props.handleChange}
            id="name-form6-12"
            required
          />
        </div>
        <p className={`text-secondary ${this.state.display}`}>
          Please enter a valid OTP!
        </p>
        <div className="col-auto mbr-section-btn align-center">
          <button
            type="submit"
            className="btn btn-success float-right"
            onClick={this.handleVerify}
            disabled={this.props.verifyBtnLoading}
          >
            <span
              className="mobi-mbri mobi-mbri-right mbr-iconfont mbr-iconfont-btn"
              style={{ fontSize: "25px" }}
            ></span>
            {this.props.verifyBtnLoading ? "Verifying" : "Verify"}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    verifyBtnLoading: state.auth.verifyBtnLoading,
  };
};
// const mapDispatchToProps = (dispatch) => {
//   return {
//     onPostOTP: (OTP) => dispatch(actions.postOTP(OTP)),
//   };
// };

export default withRouter(
  connect(mapStateToProps, null)(Step2)
);
